import type { AppThemeConfig } from "@/themes/theme.types.ts";

export const DefaultAppThemeConfig: AppThemeConfig = {
  name: "default",
  colorBrandDark: "220deg 10% 12%",
  colorBackgroundGradientFrom: "58deg 25% 81%",
  colorBackgroundGradientTo: "208deg 6% 55%",
};
export const GreenAppThemeConfig: AppThemeConfig = {
  name: "green",
  colorBrandDark: "128deg 75% 14%",
  colorBackgroundGradientFrom: "104deg 42% 66%",
  colorBackgroundGradientTo: "110deg 84% 20%",
};
export const RedGrayAppThemeConfig: AppThemeConfig = {
  name: "red_gray",
  colorBrandDark: "0deg 99% 50%",
  colorBackgroundGradientFrom: "270deg 2% 21%",
  colorBackgroundGradientTo: "0deg 0% 85%",
};
export const PurpleAppThemeConfig: AppThemeConfig = {
  name: "purple",
  colorBrandDark: "252deg 86% 33%",
  colorBackgroundGradientFrom: "235deg 100% 83%",
  colorBackgroundGradientTo: "265deg 67% 81%",
};
export const BlueAppThemeConfig: AppThemeConfig = {
  name: "blue",
  colorBrandDark: "218deg 82% 50%",
  colorBackgroundGradientFrom: "185deg 77% 88%",
  colorBackgroundGradientTo: "218deg 77% 29%",
};
export const WaveAppThemeConfig: AppThemeConfig = {
  name: "wave",
  colorBrandDark: "239deg 100% 60%",
  colorBackgroundGradientFrom: "215deg 100% 95%",
  colorBackgroundGradientTo: "230deg 100% 75%",
};
export const MaxAppThemeConfig: AppThemeConfig = {
  name: "max",
  colorBrandDark: "313deg 74% 28%",
  colorBackgroundGradientFrom: "51deg 100% 66%",
  colorBackgroundGradientTo: "354deg 61% 71%",
};
export const SkylineAppThemeConfig: AppThemeConfig = {
  name: "skyline",
  colorBrandDark: "310deg 74% 47%",
  colorBackgroundGradientFrom: "182deg 100% 66%",
  colorBackgroundGradientTo: "321deg 78% 44%",
};
export const NeoAppThemeConfig: AppThemeConfig = {
  name: "neo",
  colorBrandDark: "205deg 66% 28%",
  colorBackgroundGradientFrom: "202deg 54% 72%",
  colorBackgroundGradientTo: "202deg 79% 93%",
};

export const MidnightBlueAppThemeConfig: AppThemeConfig = {
  name: "midnight_blue",
  colorBrandDark: "224deg 44% 15%",
  colorBackgroundGradientFrom: "0deg 0% 76%",
  colorBackgroundGradientTo: "248deg 32% 67%",
};

export const VioletAppThemeConfig: AppThemeConfig = {
  name: "violet",
  colorBrandDark: "246deg 65% 44%",
  colorBackgroundGradientFrom: "245deg 100% 91%",
  colorBackgroundGradientTo: "224deg 10% 70%",
};

export const OrangeAppThemeConfig: AppThemeConfig = {
  name: "orange",
  colorBrandDark: "21deg 91% 52%",
  colorBackgroundGradientFrom: "24deg 29% 97%",
  colorBackgroundGradientTo: "21deg 100% 89%",
};

export const YellowJacketAppThemeConfig: AppThemeConfig = {
  name: "yellow_jacket",
  colorBrandDark: "240deg 2% 8%",
  colorBackgroundGradientFrom: "0deg 0% 87%",
  colorBackgroundGradientTo: "0deg 0% 79%",
  colorSidebar: "48deg 100% 50%",
};

export const ElectricGreenAppThemeConfig: AppThemeConfig = {
  name: "electric_green",
  colorBrandDark: "240deg 2% 8%",
  colorBackgroundGradientFrom: "128deg 100% 44%",
  colorBackgroundGradientTo: "213deg 100% 49%",
};

export const VioletOpinionAppThemeConfig: AppThemeConfig = {
  name: "violet_opinion",
  colorBrandDark: "240deg 100% 0%",
  colorBackgroundGradientFrom: "256deg 96% 64%",
  colorBackgroundGradientTo: "164deg 88% 74%",
};

export const OpenSkyAppThemeConfig: AppThemeConfig = {
  name: "open_sky",
  colorBrandDark: "209deg 100% 50%",
  colorBackgroundGradientFrom: "0deg 0% 95%",
  colorBackgroundGradientTo: "0deg 0% 80%",
};
